import { motion } from "framer-motion";
import { EnvelopeIcon, UserGroupIcon } from "@heroicons/react/24/outline";

export default function SecondSectionLoophole() {
  return (
    <section className="px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-5xl mx-auto text-center"
      >
        {/* Heading */}
        <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            LoopHole <span className="text-[#92abc4]">Studio</span>
          </h2>
        <h5 className="text-3xl md:text-4xl font-bold tracking-tight">
          Build with <span className="text-purple-600">people</span> <br className="hidden md:block" />
          who’ve done it before
        </h5>

        {/* Subheading */}
        <p className="mt-6 text-gray-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
          Loophole Studio is our internal hub for innovation, mentorship, and experimentation. It brings together builders, operators, and specialists to collaborate on ideas from early concept through to real-world execution, while also serving as our R&D engine testing new approaches, exploring emerging solutions, and shaping the future of our products and operations.
        </p>

        {/* Focus Areas */}
        {/* <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
          <span className="px-4 py-2 rounded-full bg-gray-100 text-gray-700">
            Technology
          </span>
          <span className="px-4 py-2 rounded-full bg-gray-100 text-gray-700">
            Sport
          </span>
          <span className="px-4 py-2 rounded-full bg-gray-100 text-gray-700">
            Wellness
          </span>
        </div> */}

        {/* Internal Note */}
        {/* <div className="mt-10 flex items-center justify-center gap-3 text-sm text-gray-500">
          <UserGroupIcon className="w-5 h-5" />
          <span>
            All mentors are internal. Structure and programmes are currently
            being built.
          </span>
        </div> */}

        {/* CTA */}
        <div className="mt-10">
          <a
            href="mailto:info@nextloop.sg"
            className="inline-flex items-center gap-3 px-6 py-3 rounded-full border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 transition"
          >
            <EnvelopeIcon className="w-5 h-5" />
            Interested? Email us to start a conversation
          </a>
        </div>
      </motion.div>
    </section>
  );
}
